const DigitalWorldIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    {...props}>
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.02}
      d='M29.309 11.164h-7.233c-.797 0-1.443.633-1.443 1.413v13.078c0 .78.646 1.413 1.443 1.413h7.233c.797 0 1.443-.632 1.443-1.413V12.577c0-.78-.646-1.413-1.443-1.413ZM20.633 14.295h10.119M20.633 23.791h10.119'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={1.02}
      d='M18.669 22.991h-15.8c-.757 0-1.369-.599-1.369-1.34V6.34C1.5 5.6 2.112 5 2.87 5h20.413c.758 0 1.37.599 1.37 1.341v2.901M10.528 23.186v.387c0 .688-.26 1.355-.732 1.868L8.51 26.836a.114.114 0 0 0 .084.19h8.958a.113.113 0 0 0 .084-.19l-1.285-1.395a2.76 2.76 0 0 1-.732-1.868v-.387M1.5 19.115h17.172'
    />
  </svg>
)

export default DigitalWorldIcon
